export function sendBroadcastMessage<DetailType>(type: string, detail?: DetailType) {
  const channel = new BroadcastChannel(type)
  if (typeof channel?.postMessage === 'function') channel.postMessage(detail)
}

export function listenBroadcastChannel<DetailType>(type: string, onEvent: (detail: DetailType) => void) {
  const channel = new BroadcastChannel(type)

  const handleEvent: EventListener = (event: MessageEvent) => {
    onEvent(event.data)
  }
  if (typeof channel?.addEventListener === 'function') channel.addEventListener('message', handleEvent)

  const removeEvent = () => {
    if (typeof channel?.removeEventListener === 'function') channel.removeEventListener(type, handleEvent)
  }

  return removeEvent
}
